import { Link } from "react-router-dom";
import { heroImage, hotSearch } from "@/mocks/news";

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <img
        src={heroImage}
        alt="热点爆料今日快讯主视觉插画"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/92"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-14 md:py-24">
        <div className="max-w-3xl mx-auto flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 h-8 px-3.5 rounded-full bg-primary-500 text-background-50 text-xs md:text-sm mb-6 rise-in">
            <span className="w-4 h-4 flex items-center justify-center">
              <span className="w-2 h-2 rounded-full bg-background-50 live-dot"></span>
            </span>
            今日快讯 · 刚刚发生 · 持续更新中
          </span>

          <h1 className="font-heading font-black text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight tracking-tight">
            热点爆料今日快讯
          </h1>

          <p className="mt-5 text-sm md:text-lg text-background-200 leading-relaxed max-w-2xl">
            追踪刚刚发生的热门事件，汇总热点爆料最新动态，持续更新不遗漏。想第一时间吃透今日瓜料，点开这里就能看到新鲜出炉的爆料内容。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/#trending"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-fire-line"></i>
              </span>
              查看今日热榜
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md border border-background-50/30 text-background-50 text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-megaphone-line"></i>
              </span>
              我要爆料
            </Link>
          </div>

          <div className="mt-9 w-full flex flex-wrap items-center justify-center gap-2">
            <span className="text-xs text-background-300 mr-1">热搜</span>
            {hotSearch.map((word) => (
              <Link
                key={word}
                to="/#trending"
                className="inline-flex items-center h-7 px-3 rounded-full bg-background-50/10 text-background-100 text-xs hover:bg-background-50/20 hover:text-accent-300 transition-colors whitespace-nowrap"
              >
                {word}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}